var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#fff",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M18.3 18.4h3.6c.6 0 1.2-.4 1.2-1V1.9c0-.5-.6-1-1.2-1H6.8c-.6 0-1.2.5-1.2 1v3.8"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17.5,
  height: 17.5,
  x: 0.9,
  y: 5.6,
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  rx: 1,
  ry: 1
})));
SvgCopy.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;